const getServiceOrderVariantsSettingsResponseMock = {
  defaultServiceCenterId: 'centre-1',
  isDefaultServiceCenterLocked: false,
  excludedServiceCenterIds: [],
};

const getServiceOrderVariantReportingResponseMock = {
  defaultServiceOrderGroupId: 'group-1',
  isDefaultServiceOrderGroupLocked: false,
  excludedServiceOrderGroupIds: [],
  isPreDeliveryInspection: false,
};

const getServiceOrderVariantAccountingResponseMock = {
  defaultServiceCenterId: 'centre-1',
  isDefaultServiceCenterLocked: false,
  excludedServiceCenterIds: [],
  fixedVatType: null,
  isTaxDeductible: false,
};

export const metadaWorkshopServiceOrderVariantApiMock = {
  getServiceOrderVariantsSettingsResponseMock,
  getServiceOrderVariantReportingResponseMock,
  getServiceOrderVariantAccountingResponseMock,
};
